import * as z from 'zod';

import { MediaZod } from '@/types/MediaType';

const ZolClientZod = z.object({
  id: z.number(),
  name: z.string(),
  slogan: z.string().nullable().optional(),
  logo: MediaZod.nullable().optional(),
});

export { ZolClientZod };
export type ZolClientType = z.infer<typeof ZolClientZod>;
